import { render, staticRenderFns } from "./CheckoutRentsCardGroup.vue?vue&type=template&id=818fd042"
import script from "./CheckoutRentsCardGroup.vue?vue&type=script&lang=js"
export * from "./CheckoutRentsCardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports